type ClubUrls = { [key: number]: string };

export const CLUB_URLS: Record<number, ClubUrls> = {
  4: "https://www.glimt.no/",
  298: "https://www.brann.no/",
  117: "https://www.fredrikstadfk.no/",
  63: "https://www.hamkam.no/",
  202: "https://www.fkh.no/",
  306: "https://www.kaaffa.no/",
  785: "https://www.kristiansundbk.no/",
  177: "https://www.lsk.no/",
  3: "https://www.moldefk.no/",
  270: "https://www.odd.no/",
  145: "https://www.rbk.no/",
  195: "https://www.sandefjordfotball.no/",
  797: "https://www.sarpsborg08.no/",
  816: "https://www.godset.no/",
  2: "https://www.til.no/",
  198: "https://www.vikingfotball.no/",
  15: "https://www.aafk.no/",
  205: "https://www.brynefk.no/",
  475: "https://www.eikfotball.no/",
  5: "https://www.kil.no/",
  405: "https://www.levangerfk.no/",
  161785: "https://lyn1896.no/",
  89: "https://www.miffotball.no/",
  120: "https://www.mossfk.no/",
  133568: "https://www.ranheimfotball.no/",
  59: "https://www.raufossfotball.no/",
  208313: "https://www.sandnesulf.no/",
  107: "https://www.sogndalfotball.no/",
  269: "https://www.stabak.no/",
  261: "https://www.ikstart.no/",
  169882: "https://www.vif-fotball.no/",
  126: "https://www.asanefotball.no/",
  184: "https://www.strommen-if.no/",
  171: "https://www.hodd.no/",
};

export const getClubRssUrl = (teamCode: number): string | null => {
  const clubWebUrl = CLUB_URLS[teamCode];
  if (clubWebUrl) {
    return `${clubWebUrl}rss-nyheter`;
  }
  return null;
};
